let baseUrl;

export const setBaseUrl = _baseUrl => {
  baseUrl = _baseUrl;
};

export const getBaseUrl = () => baseUrl;
